import type {
  PostCommunicationItem,
  PutCommunicationItem,
} from "@/briefpoint-client";
import type { ErrorResponse } from "@/lib/types";

export function isError(error: unknown): error is Error {
  return error instanceof Error;
}

export function isResponse(response: unknown): response is Response {
  return response instanceof Response;
}

export function isErrorResponse(response: unknown): response is ErrorResponse {
  return (
    isResponse(response) &&
    "status" in response &&
    typeof (response as ErrorResponse).status === "number"
  );
}

export function isResponseErrorWithStatus(
  error: unknown,
): error is Error & { status: number } {
  return isErrorResponse(error) && typeof error.status === "number";
}

export function isString(value: unknown): value is string {
  return typeof value === "string";
}

export function isNumber(value: unknown): value is number {
  return typeof value === "number";
}

export const isStringArray = (value: unknown): value is string[] => {
  return (
    Array.isArray(value) && value.every((item) => typeof item === "string")
  );
};

// Type guard to check if a value is a PutCommunicationItem, which is just like a PostCommunicationItem but with an id
export function isPutCommunicationItem(
  value: PutCommunicationItem | PostCommunicationItem,
): value is PutCommunicationItem {
  return (
    typeof value === "object" &&
    value !== null &&
    "id" in value &&
    typeof value.id === "string"
  );
}
